"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RecommendationsBar = void 0;
var _mui = require("@ori-ui/mui");
var _analyticsData = require("@ori/analytics-data");
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _productBox = require("@ori/product-box");
var _productBoxCarousel = require("@ori/product-box-carousel");
var _shoppingContext = require("@ori/shopping-context");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactCoolInview = require("react-cool-inview");
var _zod = require("zod");
var _api = require("../api");
var _constants = require("../constants");
var _hooks = require("../hooks");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
const RECENTLY_VIEWED_PRODUCTS_LOCAL_STORAGE_KEY = 'PDP-recently-viewed-products';
const relationTypes = [
    _staticApiClientReact.StaticProductsRelationRelationType.Related,
    _staticApiClientReact.StaticProductsRelationRelationType.Samples,
    _staticApiClientReact.StaticProductsRelationRelationType.RecentlyViewed
];
const placementsFromType = {
    [_staticApiClientReact.StaticProductsRelationRelationType.Related]: _analyticsData.Placement.RelatedProducts,
    [_staticApiClientReact.StaticProductsRelationRelationType.Samples]: _analyticsData.Placement.Samples,
    [_staticApiClientReact.StaticProductsRelationRelationType.RecentlyViewed]: _analyticsData.Placement.RecentProducts
};
const translationsFromRelationType = {
    [_staticApiClientReact.StaticProductsRelationRelationType.Related]: 'related',
    [_staticApiClientReact.StaticProductsRelationRelationType.Samples]: 'samples',
    [_staticApiClientReact.StaticProductsRelationRelationType.RecentlyViewed]: 'recentlyViewed',
    [_staticApiClientReact.StaticProductsRelationRelationType.Favourite]: 'favourite',
    [_staticApiClientReact.StaticProductsRelationRelationType.Popular]: 'popular',
    [_staticApiClientReact.StaticProductsRelationRelationType.Undefined]: 'none'
};
const arrowsMode = {
    type: 'compact',
    position: 'bottom'
};
const getRecentlyViewedProductsCodes = ()=>{
    try {
        const data = localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_LOCAL_STORAGE_KEY);
        return _zod.z.array(_zod.z.string()).parse(JSON.parse(data !== null && data !== void 0 ? data : '')).slice(0, 10);
    } catch (e) {
        return [];
    }
};
const RecommendationsBar = ()=>{
    var _shoppingContext_lastAddedItem, _shoppingContext_shoppingBag_shoppingBagItems_, _products_data_data, _products_data;
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFeatureEnabled } = (0, _featureToggles.useFeatureToggles)();
    const { language } = (0, _i18n.useTranslationsWithNamespaces)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { atpClusterId, customerTypeId, visitorSegment, loading: loadingSegmentationParameters } = (0, _presentationHttp.useUserSegmentationData)();
    const { tenant } = (0, _environment.useEnvironment)();
    const productBoxConfiguration = (0, _api.useProductBoxConfiguration)();
    const { shoppingContext, isLoading: loadingShoppingContext } = (0, _shoppingContext.useShoppingContext)();
    const { inView, observe } = (0, _reactCoolInview.useInView)({
        rootMargin: '100px'
    });
    var _shoppingContext_lastAddedItem_itemCode, _ref;
    const productCode = (_ref = (_shoppingContext_lastAddedItem_itemCode = shoppingContext === null || shoppingContext === void 0 ? void 0 : (_shoppingContext_lastAddedItem = shoppingContext.lastAddedItem) === null || _shoppingContext_lastAddedItem === void 0 ? void 0 : _shoppingContext_lastAddedItem.itemCode) !== null && _shoppingContext_lastAddedItem_itemCode !== void 0 ? _shoppingContext_lastAddedItem_itemCode : shoppingContext === null || shoppingContext === void 0 ? void 0 : (_shoppingContext_shoppingBag_shoppingBagItems_ = shoppingContext.shoppingBag.shoppingBagItems[0]) === null || _shoppingContext_shoppingBag_shoppingBagItems_ === void 0 ? void 0 : _shoppingContext_shoppingBag_shoppingBagItems_.itemCode) !== null && _ref !== void 0 ? _ref : '';
    var _shoppingContext_customerId;
    const customerId = (_shoppingContext_customerId = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.customerId) !== null && _shoppingContext_customerId !== void 0 ? _shoppingContext_customerId : _auth.NOT_LOGGED_IN_USER_ID;
    const recommendations = (0, _staticApiClientReact.useGetTenantProductRelations)(tenant, productCode, {
        lang: language,
        atpClusterId: atpClusterId !== null && atpClusterId !== void 0 ? atpClusterId : undefined,
        relationTypes
    }, {
        swr: {
            enabled: !!inView && !loadingSegmentationParameters,
            // fix type in utils
            ...(0, _checkoutUtils.getRetryErrorSwrOptions)()
        }
    });
    const recommendationsData = (0, _react.useMemo)(()=>{
        if (productCode && !recommendations.data) {
            return [];
        }
        return relationTypes.map((relationType)=>{
            var _recommendations_data;
            return relationType === _staticApiClientReact.StaticProductsRelationRelationType.RecentlyViewed ? {
                relationType,
                productCodes: getRecentlyViewedProductsCodes()
            } : (_recommendations_data = recommendations.data) === null || _recommendations_data === void 0 ? void 0 : _recommendations_data.relations.find((relation)=>relation.relationType === relationType);
        }).filter((recommendation)=>recommendation !== undefined && recommendation.productCodes.length > 0);
    }, [
        recommendations.data,
        productCode
    ]);
    const [activeTab, setActiveTab] = (0, _react.useState)();
    // Select first available tab after data changes if it is empty/invalid
    (0, _react.useEffect)(()=>{
        setActiveTab((oldActiveTab)=>{
            var _recommendationsData_find;
            const tab = recommendationsData.find((d)=>d.relationType === oldActiveTab);
            if (tab !== undefined && tab.productCodes.length > 0) {
                return oldActiveTab;
            }
            return (_recommendationsData_find = recommendationsData.find((r)=>r.productCodes.length)) === null || _recommendationsData_find === void 0 ? void 0 : _recommendationsData_find.relationType;
        });
    }, [
        recommendationsData
    ]);
    const currentTab = recommendationsData.find((d)=>d.relationType === activeTab);
    var _currentTab_productCodes;
    const productCodes = (_currentTab_productCodes = currentTab === null || currentTab === void 0 ? void 0 : currentTab.productCodes) !== null && _currentTab_productCodes !== void 0 ? _currentTab_productCodes : [];
    const products = (0, _staticApiClientReact.useGetTenantApplicationsProductBox)(tenant, {
        lang: language,
        atpClusterId: atpClusterId !== null && atpClusterId !== void 0 ? atpClusterId : undefined,
        customerTypeId: customerTypeId !== null && customerTypeId !== void 0 ? customerTypeId : undefined,
        visitorSegment: visitorSegment !== null && visitorSegment !== void 0 ? visitorSegment : undefined,
        productCodes
    }, {
        swr: {
            // fix type in utils
            ...(0, _checkoutUtils.getRetryErrorSwrOptions)(),
            revalidateIfStale: false,
            enabled: productCodes.length > 0
        }
    });
    const productsData = (0, _react.useMemo)(()=>{
        var _products_data_data, _products_data;
        var _products_data_data_products;
        return (0, _productBox.mapProductBoxesFromStaticApi)({
            data: (_products_data_data_products = (_products_data = products.data) === null || _products_data === void 0 ? void 0 : (_products_data_data = _products_data.data) === null || _products_data_data === void 0 ? void 0 : _products_data_data.products) !== null && _products_data_data_products !== void 0 ? _products_data_data_products : [],
            isAnonymousUser: !(0, _auth.isAuthenticatedCustomer)(customerId)
        });
    }, [
        customerId,
        (_products_data = products.data) === null || _products_data === void 0 ? void 0 : (_products_data_data = _products_data.data) === null || _products_data_data === void 0 ? void 0 : _products_data_data.products
    ]);
    const onTabChange = (0, _react.useCallback)((_, value)=>setActiveTab(value), []);
    if (loadingShoppingContext || loadingSegmentationParameters || recommendations.isValidating) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
            ref: observe,
            height: 120
        });
    }
    if (recommendationsData.length === 0) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: observe
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styled.BasketCard, {
        ref: observe,
        children: [
            !!activeTab && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Tabs, {
                allowScrollButtonsMobile: true,
                scrollButtons: true,
                centered: true,
                value: activeTab,
                sx: {
                    marginBottom: {
                        xs: 3,
                        sm: 6
                    }
                },
                onChange: onTabChange,
                children: recommendationsData.map((v)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Tab, {
                        disableRipple: true,
                        "data-testid": getTestId(v.relationType),
                        label: formatMessage(translationsFromRelationType[v.relationType]),
                        value: v.relationType
                    }, v.relationType))
            }),
            !!currentTab && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productBoxCarousel.ProductBoxCarousel, {
                data: productsData,
                loading: products.isValidating,
                analyticsPlacement: placementsFromType[currentTab.relationType],
                customerId: customerId,
                tenant: tenant,
                hideRating: !(productBoxConfiguration === null || productBoxConfiguration === void 0 ? void 0 : productBoxConfiguration.isRatingsAndReviewsEnabled),
                hideSubscription: !isFeatureEnabled(_constants.CheckoutBasketFeature.PersonalSubscriptions) || !(productBoxConfiguration === null || productBoxConfiguration === void 0 ? void 0 : productBoxConfiguration.isSubscriptionEnabled),
                withTranslationsProvider: false,
                arrowsMode: arrowsMode
            }, currentTab.relationType)
        ]
    });
};
exports.RecommendationsBar = RecommendationsBar;
